module.exports = __webpack_public_path__ + "img/yscy_a_informationi2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/yscy/_img/yscy_a_informationi2.png
// module id = VILn
// module chunks = 2